export default __webpack_public_path__ + "static/media/NotoSansTC-Regular.b018ff7b.otf";